var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[(!_vm.authUserId)?_c('AuthForm',{staticClass:"ma-3",staticStyle:{"width":"800px","max-width":"800px"},attrs:{"outlined":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }